import * as T from './actionTypes';

const INIT_STATE = {
  cost: null,
  loading: false,
  error: null,
};

const AssetCost = (state = INIT_STATE, action) => {
  switch (action.type) {
    case T.FETCH_ASSET_COST:
      return { ...state, loading: true, error: null };
    case T.FETCH_ASSET_COST_SUCCESS:
      return { ...state, loading: false, cost: action.payload };
    case T.FETCH_ASSET_COST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case T.CLEAR_ASSET_COST:
      return INIT_STATE;
    default:
      return state;
  }
};

export default AssetCost;
